import React from 'react';
import {
  documentToReactComponents,
  Options as documentToReactComponentsOptions,
} from '@contentful/rich-text-react-renderer';
import { Document, INLINES, Inline, Block, BLOCKS } from '@contentful/rich-text-types';
import deepMerge from 'ts-deepmerge';

import { Link } from '../PlatformFunctionality';
import { styles } from './RichText.css';
import { classNames } from '@jbhi-fi/lanyard-ui/global/utils';
import { renderListItem } from './renderListItem';

export type RichTextProps = {
  document: Document;
  renderOptions?: documentToReactComponentsOptions;
  containerClass?: string;
};

export const NodeHyperlink = (node: Inline | Block, children: React.ReactNode) => (
  <Link href={node.data?.uri}>{children}</Link>
);

const defaultOptions: documentToReactComponentsOptions = {
  renderNode: {
    [INLINES.HYPERLINK]: NodeHyperlink,
    [BLOCKS.LIST_ITEM]: renderListItem,
  },
};

export const RichText = ({ document, renderOptions = {}, containerClass }: RichTextProps) => {
  const mergedOptions = deepMerge(defaultOptions, renderOptions);

  return (
    <div className={classNames(containerClass, styles.container)}>
      {documentToReactComponents(document, mergedOptions)}
    </div>
  );
};
